"use strict";
/**
 * 打关数据格式化
 */
class ReplayDataFormatter {
    constructor() {
        this.defaultFormatVersion = "3";
        this.defaultUnformatVersion = "0";
        this.formatterClassMap = {};
        this.formatterMap = {};
        this.registerClass("0", require("./ReplayDataFormatter_v0"));
        this.registerClass("1", require("./ReplayDataFormatter_v1"));
        this.registerClass("2", require("./ReplayDataFormatter_v2"));
        this.registerClass("3", require("./ReplayDataFormatter_v2")); // v3是为了增加广告道具的恢复，没有更改格式
    }
    /**
     * 注册格式化类
     * ver: 对应数据版本号
     * formatterClass: 实现接口IReplayDataFormatter的格式化类
     */
    registerClass(ver, formatterClass) {
        this.formatterClassMap[ver] = formatterClass;
    }
    format(org, ver) {
        ver = ver || this.defaultFormatVersion;
        if (typeof (org) === "string")
            org = JSON.parse(org);
        let formatter = this.getFormatter(ver);
        let formatted = formatter.format(org);
        formatted.$v = ver;
        return formatted;
    }
    unformat(formatted) {
        if (typeof (formatted) === "string")
            formatted = JSON.parse(formatted);
        let ver = formatted.$v || this.defaultUnformatVersion;
        let formatter = this.getFormatter(ver);
        let result = formatter.unformat(formatted);
        delete result.$v;
        return result;
    }
    getFormatter(ver) {
        let formatter = this.formatterMap[ver];
        if (formatter == null) {
            let formatterClass = this.formatterClassMap[ver];
            if (formatterClass != null)
                formatter = new formatterClass();
            this.formatterMap[ver] = formatter;
        }
        assert(formatter, "failed to find formatter for " + ver);
        return formatter;
    }
}
module.exports = ReplayDataFormatter;
